<section [ngClass]="renderMode">
  <header>
    <h1 mat-dialog-title [ngClass]="data.titleIcon ? 'has-icon' : ''">
      @if (data.titleIcon.startsWith('bhi-')) {
        <i class="{{ data.titleIcon }}"></i>
      }
      @if (data.titleIcon.endsWith('-KyloeIcon')) {
        <i class="{{ data.titleIcon }}"></i>
      }
      @if (!data.titleIcon.startsWith('bhi-') && !data.titleIcon.endsWith('-KyloeIcon')) {
        <mat-icon [fontIcon]="data.titleIcon"></mat-icon>
      }
      <span [innerHTML]="data.title"></span>
    </h1>
  </header>
  <div mat-dialog-content>
    @if (data.messageIcon.startsWith('bhi-')) {
      <i></i>
    }
    @if (!data.messageIcon.startsWith('bhi-')) {
      <mat-icon [fontIcon]="data.messageIcon"></mat-icon>
    }
    @if (data.message) {
      <h2 [innerHTML]="data.message"></h2>
    }
  </div>
  <section mat-dialog-actions class="footer-btns" [ngClass]="data.hideCancelButton || data.hideConfirmButton ? 'one-button' : ''">
    @if (!data.hideCancelButton) {
      <button mat-button (click)="onNoClick()" theme-style="nav" class="danger-btn-hover" appRipple>
        {{ data.cancelButtonText }}
      </button>
    }
    @if (!data.hideConfirmButton) {
      <button
        mat-button
        [mat-dialog-close]="data"
        theme-style="nav"
        [matTooltip]="data.confirmButtonTooltip"
        matTooltipShowDelay="500"
        [disabled]="data.confirmButtonDisabled"
        appRipple
        >
        {{ data.confirmButtonText }}
      </button>
    }
  </section>
</section>
